import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=bc024db4&scoped=true"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=bc024db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc024db4",
  null
  
)

export default component.exports